<template>
    <div class="page-404">
        <div class="container wrapper-white">
            <img 
                src="@/assets/images/404.svg" 
                alt="404" 
                class="illu-404"
            >
            <p class="mb-20">
                Il semble que la page que vous essayez d'atteindre n'existe pas…
            </p>
            <router-link 
                to="/"
                class="back-link"
            >
                Retour à l'accueil
            </router-link>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'Page404'
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/styles/variables';

    .page-404 {
        text-align: center;
    }
    .illu-404 {
        display: inline-block;
        width: 20rem;
        max-width: 100%;
        margin-bottom: 1rem;
    }
    .back-link {
        &, &:visited {
            color: $color-primary;
            font-weight: 600;
            text-decoration: none;
        }
        &:hover {
            opacity: .9;
        }
        &::after {
            content: map-get($icons, arrow-right);
            font-family: $font-icons;
            font-size: .8rem;
        }
    }
</style>